import { useContext } from "react";
import Context from "../context";
export default function useLanguageProvider() {
    return useContext(Context);
}
